import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { SelectPuerpery } from "../Puerpera/SelectPuerpery";
import { useUserData } from "../../hooks";
import { URL, Fetcher as F } from "../../api";

export const BookRoomSelectPuerpery = () => {
  const navigate = useNavigate();
  const user = useUserData();

  const handleSelect = useCallback(
    async (pid) => {
      if (!user?.employee_id) return;
      const payload = { employee: user.employee_id, puerpera_id: pid };
      const bookroom = await F.post(`${URL.book.room}`, payload);
      if (bookroom?.id) {
        navigate(`/bookroom/${bookroom.id}/edit`);
      }
    },
    [navigate, user]
  );
  return <SelectPuerpery targetBlock={handleSelect} />;
};
